import React, { useState } from "react";
import { Chart } from "react-google-charts";
import { connect } from "react-redux";

import { ReactComponent as InfoIcon } from "icons/info.svg";
import { Select } from "expano-components";

const getTotal = (data = {}) => {
  const total_data = Object.values(data).map(
    ({ count }) => count
  );
  return total_data.reduce((a, acc) => a + acc, 0);
};

const createChartData = (data) => {
  const chart_data = [["Element", "Ilość", "Ilość"]];
  try {
    if (!data) return chart_data;
    const keys = Object.keys(data);
    keys.forEach((key) => {
      chart_data.push([
        `${key}\n`,
        key === "Starsze" ? data[key]?.count : null,
        key !== "Starsze" ? data[key]?.count : null,
      ]);
    });
  } catch (error) {
    console.log(error);
  }
  return chart_data;
};

const infoByType = (type) => {
  switch (type) {
    case "new_prepared_at_days_ago":
      return "Zamówienia w statusach new pogrupowane na podstawie prepared_at";
    case "in_progress_prepared_at_days_ago":
      return "Zamówienia w statusach picked, packed pogrupowane na podstawie prepared_at";
    case "completed_prepared_at_days_ago":
      return "Zamówienia w statusie completed z dzisiejszą datą skompletowania, pogrupowane na podstawie prepared_at";
    default:
      return "";
  }
};

const PreparedChart = ({ data }) => {
  const [type, setType] = useState(
    "new_prepared_at_days_ago"
  );

  const chart_data = createChartData(data?.stats?.[type]);

  const total_new_prepared_at_days_ago = getTotal(
    data?.stats?.new_prepared_at_days_ago
  );

  const total_in_progress_prepared_at_days_ago = getTotal(
    data?.stats?.in_progress_prepared_at_days_ago
  );

  const total_completed_prepared_at_days_ago = getTotal(
    data?.stats?.completed_prepared_at_days_ago
  );

  const options = [
    {
      label: `Nowe (${total_new_prepared_at_days_ago})`,
      value: "new_prepared_at_days_ago",
    },
    {
      label: `W trakcie (${total_in_progress_prepared_at_days_ago})`,
      value: "in_progress_prepared_at_days_ago",
    },
    {
      label: `Zrealizowane (${total_completed_prepared_at_days_ago})`,
      value: "completed_prepared_at_days_ago",
    },
  ];

  const info = infoByType(type);

  return (
    <div className="dashboard chart">
      <div className="dashboard__header chart-box__header">
        <h2 className="dashboard__title heading">
          Według daty
        </h2>
        <div className="chart-box__header__aside">
          <Select
            options={options}
            handleChange={(value) => setType(value)}
            value={options.find(
              ({ value }) => value === type
            )}
          />
          <div className="info-icon" data-tooltip={info}>
            <InfoIcon />
          </div>
        </div>
      </div>
      <Chart
        options={{
          isStacked: true,
          chartArea: { width: "85%" },
          vAxis: { minValue: 0, maxValue: 15 },
          hAxis: {
            textStyle: {
              fontSize: 13,
              color: "#595D6E",
            },
          },
          legend: { position: "none" },
          colors: ["#ffb822", "#5D78FF"],
        }}
        chartType="ColumnChart"
        loader={null}
        width="100%"
        height="300px"
        data={chart_data}
      />
    </div>
  );
};

export default connect(({ dashboard: { data } }) => ({
  data,
}))(PreparedChart);
